import { apiWithAuth } from "./utils";

export class Contact {
  constructor(private readonly mountPath: string) {}

  // Create a new contact
  async createContact(contactData: { [key: string]: any }) {
    return await apiWithAuth.post(this.mountPath, contactData);
  }

  // Get a single contact by ID
  async getContactById(id: number) {
    return await apiWithAuth.get(`${this.mountPath}/${id}`);
  }

  // List all contacts (optionally support pagination/query)
  async listContacts(queryParams: { [key: string]: any } = {}) {
    const queryString = new URLSearchParams(queryParams).toString();
    return await apiWithAuth.get(`${this.mountPath}?${queryString}`);
  }

  // Update contact by ID
  async updateContact(id: number, updateData: { [key: string]: any }) {
    return await apiWithAuth.put(`${this.mountPath}/${id}`, updateData);
  }

  // Delete contact by ID
  async deleteContact(id: number) {
    return await apiWithAuth.delete(`${this.mountPath}/${id}`);
  }

  // Bulk upload contacts via FormData
  async bulkUploadContacts(formData: FormData) {
    return await apiWithAuth.post(`${this.mountPath}/bulk-upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}
